/**
 * Marketing page every freemium upsell links out to. Shared so the settings
 * upsell cards and the locked dashboard can never drift apart.
 */
export const SOURCE_PRODUCT_URL = 'https://www.fountain.com/source';
